/**
 * Legacy savings finish page for tenants with useLegacyOperationUrls (e.g. Rakbank).
 * URL: /assets/[assetId]/buy/savings/FINISHED|FAILED (matches partner FINISHED/FAILED regex).
 * Mounted from apps/rakbank/.../(legacy-freeze)/buy/savings/[offerStatusOrId]/page.tsx.
 * Renders FinishTradeWithDesktopWrapper with operation 'savings'.
 */

import { notFound } from 'next/navigation';
import { isOrderFinishRouteStatus } from '@bts-web/data-layer/server';
import { FinishTradeWithDesktopWrapper } from '../../FinishTrade/FinishTradeWithDesktopWrapper.use-server/FinishTradeWithDesktopWrapper.use-server';

interface LegacyFreezeAcceptSavingsFinishPageProps {
  params: Promise<{ assetId?: string; offerStatusOrId?: string }>;
  searchParams?: Promise<Record<string, string | undefined>>;
}

export async function LegacyFreezeAcceptSavingsFinishPage({
  params,
  searchParams,
}: LegacyFreezeAcceptSavingsFinishPageProps) {
  const awaitedParams = await params;

  const assetId = awaitedParams.assetId;

  const segment = awaitedParams.offerStatusOrId;

  if (assetId == null || segment == null) {
    notFound();
  }

  if (!isOrderFinishRouteStatus(segment)) {
    notFound();
  }

  const search = searchParams != null ? await searchParams : {};

  return (
    <FinishTradeWithDesktopWrapper
      params={Promise.resolve({
        assetId,
        operation: 'savings',
        offerTransactionStatus: segment,
        offerId: search?.offerId,
      })}
      searchParams={Promise.resolve((search ?? {}) as Record<string, string>)}
    />
  );
}
